import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import { url_servicios, ip, url_inland, url_moduleCSL, url_login_csl, systemId } from 'app/domain/publico';
import { Usuario } from 'app/domain/usuario';
import { error } from 'util';

declare var AesUtil: any;

declare var jQuery: any;
@Injectable()
export class LoginService {

    private ip = url_servicios;
    private url = this.ip + "oauth/token";

    private options;
    private logged: boolean;
    private key_token = 'key_apm';

    ruta_moduleCSL: any;
    ruta_inland: any;
    ruta_login_csl: any;

    body_inland: any;

    constructor(private http: Http, private router: Router) {
        this.horrores = "";
        var headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        this.options = new RequestOptions({ headers: headers });
    }

    isLogged(): boolean {
        if (window.localStorage.getItem(this.key_token)) {
            return true;
        }
        return false;
    }


    private username: string;
    login(usuario, contrasena) {
        localStorage.setItem('test', new AesUtil('zxcfgh45#s-)1').encrypt(contrasena));
        this.horrores = "";
        var credenciales = "username=" + usuario + "&password=" + contrasena + "&grant_type=password&client_id=apmApiWebApp_clientID&client_secret=apm_apiPASSWORD&scope=write";
        return this.http.post(this.url, credenciales, this.options)
            .toPromise()
            .then(resp => {
                window.localStorage.setItem(this.key_token, resp.json().access_token);

                var headers = new Headers();
                headers.append('Authorization', `Bearer ${resp.json().access_token}`);
                var option = new RequestOptions({ headers: headers });

                return this.http.get(url_servicios + "acceso/web?codigo=" + usuario, option)
                    .toPromise()
                    .then(user => {
                        return user.json();
                    }).catch((error) => {
                        this.error_login(error)
                    });
            }).catch((error) => {
                this.error(error, this.horrores);
            });
    }

    //para springboot (http://localhost:8457/ModuleCSL/module/csl/CSLIntegracionServiceImp/cslintegrarContainerServices?codigo=47435983&token=guido)
    //para servlet (http://localhost:8087/ModuleCSL/module/csl/CSLIntegracionServiceImp/cslintegrarContainerServices?codigo=47435983&token=guido)

    validarUsuarioIntegracion(codigo, token) {
        var codigoEncripted = new AesUtil().encrypt(codigo);
        var tokenEncripted = new AesUtil().encrypt(token);
        this.ruta_moduleCSL = url_moduleCSL + "ModuleCSL/module/csl/CSLIntegracionServiceImp/cslintegrarContainerServices?" + "codigo=" + encodeURIComponent(codigoEncripted) + "&token=" + encodeURIComponent(tokenEncripted);

        return this.http.get(this.ruta_moduleCSL)
            .toPromise()
            .then(resp => {
                return resp.json();
            });
    }

    iniciarLlenos(codigo, token) {
        var tokenEncripted = new AesUtil().encrypt(token);

        let datos_enviar = {
            SEG: {
                F: {
                    Usuario: codigo,
                    ClaveMD5: localStorage.getItem('test'),
                    Sistema_id: systemId
                }
            },
            AUT: {
                F: {
                    clientId: "API_APM_INLANDNET",
                    clientSecret: "33caa750333af31d49d39e9251ecb592",
                    latitude: "",
                    longitude: "",
                    so: "",
                    browser: ""
                }
            }
        };

        this.ruta_inland = url_inland + "inlandnetfull/Inlandnet/security/UserServiceImp/segloginAcceder";
        this.body_inland = JSON.stringify(datos_enviar);

        return this.http.post(this.ruta_inland, this.body_inland)
            .toPromise()
            .then(resp => {
                let data = resp.json().result;
                let dataEncripted = new AesUtil().encrypt(JSON.stringify(data));

                this.ruta_login_csl = url_login_csl + "#/Login?data=" + encodeURIComponent(dataEncripted) + "&dd=" + encodeURIComponent(localStorage.getItem('test'));

                window.open(this.ruta_login_csl, "_blank");
            });
    }

    horrores = "";
    private error_login(e) {
        switch (e.status) {
            case 400:
                this.logout();
                this.horrores = JSON.parse(e._body).message;
            case 500:
                throw "Error interno del servidor"
            default:
                throw new Error(`${JSON.parse(e._body).error_description}`)
        }
    }

    private error(e, error) {
        if (error == "")
            switch (e.status) {
                case 400:
                    this.logout();
                    throw "Credenciales Incorrectas";
                case 500:
                    throw "Error interno del servidor"
                default:
                    throw new Error(`${JSON.parse(e._body).error_description}`)
            }
        else
            throw error;
    }


    logout() {
        window.localStorage.removeItem("cse_technology");
        window.localStorage.removeItem("cse_modality");
        window.localStorage.removeItem("key_apm");
        window.localStorage.removeItem("usuario");
    }

    //("codigo") String codigo, ("ruc") String ruc, ("clave1") String clave1, ("clave2") String clave2, ("title") String title, ("body") String body
    reset_password(ruc, codigo, clave1, clave2) {
        var titulo = " -- Contraseña nueva -- ";
        var method = "cambio/clave?ruc=" + ruc + "&codigo=" + codigo + "&clave1=" + clave1 + "&clave2=" + clave2 + "&title=" + titulo + "&body=" + this.armar_form(clave1);

        return this.http.post(url_servicios + method, "")
            .map(resp => {
                return resp.json()
            }, error => {
                this.error_clave(error)
            })
    }

    private armar_form(clave) {
        var html = '<div style=" width: 400px; border: 1px solid #004165; "><div style="padding: 0.5rem 0.5rem !important;"><div class="receipt-head text-center" style=" text-align: center; background-color: #004165; "><img class="m-0" src="http://' + ip + '/assets/img/logo-01.png" width="200px"></div><div style="text-align: center ;color: #004165; margin-top: 1rem !important; margin-bottom: 1rem !important;"><div style="color: orangered"> Su nueva contraseña es : </div><h2>' + clave + '</h2></div></div></div>';

        var base64 = this.b64EncodeUnicode(html);

        for (let i of base64.split("+")) {
            base64 = base64.replace('+', '-');
        }

        for (let i of base64.split("/")) {
            base64 = base64.replace('/', '_');
        }

        return base64;
    }

    private b64EncodeUnicode(str) {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt(p1, 16))
        }))
    }



    private error_clave(e: any) {
        switch (e.status) {
            case 400:
                return Observable.throw(JSON.parse(e._body).message);
            case 500:
                return Observable.throw("Internal Server Error");
            default:
                return Observable.throw("Ocurrio un error");
        }
    }

}




// WEBPACK FOOTER //
// C:/carlos/wks/web/vacios_web/src/app/view/login/login.service.ts